import { HexColorPicker } from 'react-colorful';
import { cn } from '../../lib/utils';
import {
  mediumText,
  baseTextSize,
  secondaryText,
} from '../../styling/stylingHelper';

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label?: string;
}

export const ColorPicker = ({ value, onChange, label }: ColorPickerProps) => {
  return (
    <div className="space-y-3">
      {label && (
        <label className={cn(mediumText, baseTextSize, secondaryText)}>
          {label}
        </label>
      )}

      {/* Color picker */}
      <div className="flex flex-col gap-3">
        <HexColorPicker color={value} onChange={onChange} />

        {/* Display current color value */}
        <div className="flex items-center gap-2">
          <div
            className="w-10 h-10 rounded-lg border-2 border-gray-300 dark:border-gray-600"
            style={{ backgroundColor: value }}
          />
          <span className={cn("text-sm font-mono", secondaryText)}>
            {value.toUpperCase()}
          </span>
        </div>
      </div>
    </div>
  );
};
